import { formatUnitOfProductSoldCell } from "../../../utils/unitOfProductSoldDisplay";

/** Short date for Scope 3 approval list cells (en-GB). */
export const formatDateCell = (d) => {
  if (d === undefined || d === null || d === "") return "";
  try {
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) return String(d);
    return dt.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return String(d);
  }
};

/**
 * Display `{ value, unit }` API fields, or a primitive, as `"12 MT"` / `"N/A"`.
 */
export const formatValueUnitField = (raw) => {
  if (raw == null) return "N/A";
  if (typeof raw === "object") {
    const v = raw.value !== undefined && raw.value !== null ? raw.value : "";
    const u = raw.unit != null ? String(raw.unit).trim() : "";
    const combined = `${v} ${u}`.trim();
    return combined || "N/A";
  }
  return String(raw).trim() || "N/A";
};

/**
 * Use-of-sold-products: `unitOfProductSold` may be `{ value, unit }` or legacy scalar + `unitOfProductSoldUnit`.
 * Unit label prefers `masterProduct.soldUnit` when the API includes it.
 */
export const formatUnitOfProductSoldFromRow = (row) => formatUnitOfProductSoldCell(row);
